function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.52448 4.14857L5.98633 2.84937",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.02381 7.64948L1.72461 7.11133",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9761 7.64948L16.2753 7.11133",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4756 4.14857L12.0137 2.84937",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.875 11.25H1.125",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.625 14.0625H3.375",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.93291 11.2499C4.76029 10.6236 4.73464 9.96592 4.85796 9.32808C4.98128 8.69024 5.25024 8.0895 5.64388 7.57268C6.03751 7.05587 6.54519 6.63694 7.12733 6.34857C7.70947 6.06019 8.35035 5.91016 9 5.91016C9.64965 5.91016 10.2905 6.06019 10.8727 6.34857C11.4548 6.63694 11.9625 7.05586 12.3561 7.57268C12.7498 8.08949 13.0187 8.69023 13.142 9.32807C13.2654 9.96591 13.2397 10.6236 13.0671 11.2499",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgSunHorizon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSunHorizon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sun-horizon.d4270614.svg";
export { ForwardRef as ReactComponent };